<template>
	<div>
		<formmain ref="formmain" :windowType="windowType" :width="width" :height="height"
			:flowprogressid="flowprogressid" :loading="loading" @show="show" @hide="hide">
			<template #title>
				<div>{{extra.title?extra.title:title}}</div>
			</template>
			<template #main>
				<div v-if="id" style="font-size: 14px;font-weight: bolder;margin-left: 20px;">{{id}}</div>
				<div :ref="name+'_form'" style="margin-top: 20px;"></div>
			</template>
			<template #footer>
				<vxe-button status="" content="取消" @click="hide"></vxe-button>
				<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
			</template>
		</formmain>
		<component :is="formModule.component" v-if="formModule.show" :name="formModule.name" :id="formModule.id"
			:controlltype="formModule.controlltype" :extra="formModule.extra" :foreingKey="formModule.foreingKey" />
		<event-form :data="eventData" :param="foreingKey" ref="eventForm" @submit="eventSubmit" @back="eventBack" />
		<expression-form :data="expressionData" :param="foreingKey" ref="expressionForm" @submit="expressionSubmit" @back="expressionBack" />	
	</div>
</template>
<script>
	const flownodeRes = {
		title: '流程节点',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [{
					"type": "el-divider",
					"name": 'nodetypedivider',
					"children": [
						"节点信息"
					]
				},
				{
					"type": "select",
					"field": "nodetype",
					"title": "节点类型",
					"value": null,
					"options": [{
							"value": 1,
							"label": "人员",
							"disabled": false
						},
						{
							"value": 2,
							"label": "逻辑",
							"disabled": false
						},
						{
							"value": 3,
							"label": "知会",
							"disabled": false
						},
						{
							"value": 996,
							"label": "子流程",
							"disabled": false
						},
						{
							"value": 997,
							"label": "审核",
							"disabled": false
						},
						{
							"value": 998,
							"label": "发起",
							"disabled": true
						},
						{
							"value": 999,
							"label": "结束",
							"disabled": true
						},
					],
					"hidden": false,
					"props": {
						"readonly": false,
						"name": "nodetype"
						
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "name",
					"title": "节点名称",
					"value": "",
					"hidden": false,
					"props": [],
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "tag",
					"title": "事项",
					"value": "协同",
					"hidden": false,
					"props": [],
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"name": 'controlldivider',
					"hidden": true,
					"children": [
						"操作设置"
					]
				},
				{
					"type": "$controll",
					"field": "controll",
					"title": "绑定操作",
					"value": "",
					"hidden": true,
					"props": [],
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "begintype",
					"title": "操作类型",
					"value": 0,
					"options": [{
							"value": 0,
							"label": "保存草稿",
							"disabled": false
						},
						{
							"value": 1,
							"label": "发起",
							"disabled": false
						}
					],
					"hidden": true,
					"props": {
						"name": "nodetype"
						
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "button",
					"field": "controller",
					"title": "操作人",
					"value": "",
					"children": ['选择'],
					"hidden": true,
					"props": {
						"size": "mini",
						"type": "primary"
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$switchs",
					"field": "jump",
					"title": "同执行人跳过",
					"value": 1,
					"hidden": true,
					"props": {
						"size": "mini",
						"type": "primary"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "button",
					"field": "event",
					"title": "后置事件",
					"value": "",
					"children": ['配置'],
					"hidden": true,
					"props": {
						"size": "mini",
						"type": "primary"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"name": 'logicdivider',
					"hidden": true,
					"children": [
						"判断逻辑"
					]
				},
				{
					"type": "$select",
					"field": "method",
					"title": "方式",
					"value": 2,
					"hidden": true,
					"options": [
						{"label":'表达式',"value":1},
						{"label":'自定义',"value":2}
					],
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$codemirror",
					"field": "code",
					"name": "判断逻辑",
					"title": "",
					"value": "<?php return true; ?>",
					"hidden": true,
					"props": {
						"options": {
							"tabSize": 4,
							"styleActiveLine": true,
							"lineNumbers": true,
							"line": true,
							"mode": "application/x-httpd-php",
							"lineWrapping": false,
							"theme": "cobalt"
						}
					},
					"col": {
						"span": 22,
						"offset": 1
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "button",
					"field": "expressionconfig",
					"title": "",
					"value": null,
					"hidden": true,
					"children": ['配置'],
					"props":{
						"type":"primary"
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"name": 'sonflowdivider',
					"hidden": true,
					"children": [
						"子流程"
					]
				},
				{
					"type": "select",
					"field": "sonflow",
					"title": "发起子流程",
					"value": "",
					"hidden": true,
					"options":[],
					"props": {
						"multiple":true,
					},
					"col": {
						"span": 24,
						"offset": 0
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"name": 'illustratedivider',
					"hidden": true,
					"children": [
						"操作说明"
					]
				},
				{
					"type": "$input",
					"field": "illustrate",
					"title": "操作说明",
					"value": "",
					"hidden": true,
					"props": {
						"type":"textarea",
						"autosize":true,
						"rows":10
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},

			],
			"option": {
				"form": {
					"labelWidth": "100px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 10,
							"offset": 1
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import formBase from '@_system/components/base/form.vue'
	import eventForm from './event.vue'
	import expressionForm from './expression.vue'
	export default {
		name: 'flownodeForm',
		extends: formBase,
		props: {

		},
		data() {
			return {
				sonflow:[],
				eventData:null,
				expressionData:null,
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {
						default: () => {
							return {}
						}
					}
				},
			}
		},
		watch: {

		},
		computed: {
			titleNotice() {
				let str = ''
				switch (this.controlltype) {
					case 1:
						str = '新增'
						break;
					case 2:
						str = '编辑'
						break;
					case 3:
						str = '预览'
						break;
				}
				if (this.extra.type == 'insert') {
					str = '插入'
				}
				return str
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeInit(next){
				this.$api.flow.getSonflow(this.foreingKey.formid).then((res)=>{
					this.sonflow = res.map((item)=>{
						return {
							value:item.id,
							label:item.name
						}
					})
					next()					
				},()=>{
					next()
				})
			},
			init() {
				new Promise((resolve) => {
					if (this.beforeInit) {
						this.beforeInit(resolve)
					} else {
						resolve()
					}
				}).then(() => {
					let res = JSON.parse(JSON.stringify(flownodeRes))
					this.rule = res.rule
					if (this.extra.defaultvalue) {
						for (let i in this.extra.defaultvalue) {
							for (let j in this.rule.rule) {
								if (this.rule.rule[j].field == i) {
									this.rule.rule[j].value = this.extra.defaultvalue[i]
								}
							}
						}
					}
					for (let i in this.rule.rule) {
						if (this.rule.rule[i].field == 'controll') {
							//console.log(this.foreingKey.flowid,11111)
							this.rule.rule[i].props = {
								flowid: this.foreingKey.flowid,
								formid: this.foreingKey.formid,
								controlltype: 1,
								componentname:this.extra.componentname
							}
						}
					}
					this.title = res.title
					this.width = res.rule.width
					this.height = res.rule.height
					this.openwindow()
				})
			},
			regestEvent(rule, fApi) {
				fApi.updateRule('nodetype', {
					on: {
						change: this.nodetypeChange
					}
				})
				fApi.updateRule('method', {
					on: {
						change: this.methodChange
					}
				})
				fApi.updateRule('controll', {
					props: {
						formid: this.foreingKey.formid,
						flowid: this.foreingKey.flowid,
						componenttype: 2,
						componentname:this.extra.componentname
					}
				})
				fApi.updateRule('controller', {
					on: {
						click: this.controllerButton
					}
				})
				fApi.updateRule('event', {
					on: {
						click: this.eventButton
					}
				})
				fApi.updateRule('expressionconfig', {
					on: {
						click: this.expressionconfigButton
					}
				})
			},
			controllerButton() {
				import('@_system/components/forms/auth/node.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'auth',
						show: true,
						extra: {
							value: this.fApi.getValue('controller'),
							type: '',
							submit: this.controllerSubmit,
							back: this.controllerBack,
							formid: this.foreingKey.formid,
						},
					}
				})
			},
			controllerBack() {
				this.formModule = {
					component: null,
					name: '',
					show: false,
					extra: {},
				}
			},
			controllerSubmit(e) {				
				this.fApi.setValue('controller', e)
			},
			get() {
				return new Promise((resolve) => {
					this.sourceData = this.extra.node.data
					this.loading = false
					resolve()
					
				})	
				// let fields = this.fApi.fields()
				// fields.forEach((item) => {
				// 	this.fApi.setValue(item, res[item])
				// 	let rule = this.fApi.getRule(item)
				// 	if (rule.on && rule.on.change && (typeof rule.on.change) === 'function') {
				// 		rule.on.change(res[item])
				// 	}
				// })
				//this.loading = false
			},
			setFormData(){
				if(this.sourceData){
					this.beforeRender(this.sourceData)
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
						let rule = this.fApi.getRule(item)
						if (rule.on && rule.on.change && (typeof rule.on.change) === 'function') {
							rule.on.change(this.sourceData[item])
						}						
					})
					this.afterGet(this.sourceData)
				}
			},
			methodChange(e){
				if(this.fApi.getValue('nodetype') == 2){
					if(e == 1){
						this.fApi.updateRule('code', {
							hidden: true
						})	
						this.fApi.updateRule('expressionconfig', {
							hidden: false
						})										
					}else{
						this.fApi.setValue({
							method: 2
						})
						this.fApi.updateRule('code', {
							hidden: false
						})
						this.fApi.updateRule('expressionconfig', {
							hidden: true
						})
					}
				}
			},
			nodetypeChange(e) {
				let divider = ['nodetypedivider','controlldivider','logicdivider','sonflowdivider','illustratedivider']
				this.fApi.hidden(true)
				this.fApi.hidden(true,divider)
				//this.fApi.setValue('controll', null)
				if (e === 1) {
					this.setStaffNode()
				}
				if (e === 2) {
					this.setLogicNode()
				}
				if (e === 3) {
					this.setInformNode()
				}	
				if (e === 996) {
					this.setSonflowNode()
				}						
				if (e === 997) {
					this.setAuditNode()
				}						
				if (e === 998) {
					this.setBeginNode()
				}
				if (e === 999) {
					this.setEndNode()
				}
				
				// this.fApi.updateRule('code', {
				// 	hidden: e !=2,
				// })
				// this.fApi.updateRule('controller', {
				// 	hidden: e !== 1 && e !== 3 && e !== 996,
				// })
				// this.fApi.updateRule('ignore', {
				// 	hidden: e !== 1 && e !== 3 && e !== 996,
				// })
				// this.fApi.updateRule('controll', {
				// 	hidden: e !== 1 && e!==3 && e !== 998,
				// })
				// this.fApi.updateRule('sonflow', {
				// 	options:this.sonflow,
				// 	hidden: e !=996,
				// })
				// this.fApi.updateRule('begintype', {
				// 	hidden: e !=996,
				// })
				// this.fApi.updateRule('tag', {
				// 	hidden: e !== 1 && e!==3 ,
				// })

			},
			setEndNode(){
				let showField = ['nodetype','name']
				let showDivider = ['nodetypedivider']
				this.fApi.setValue({
					name: '结束'
				})
				this.fApi.hidden(false, showField)
				this.fApi.hidden(false, showDivider)
			},
			setBeginNode(){
				let showField = ['nodetype','name','controll','illustrate']
				let showDivider = ['nodetypedivider','controlldivider','illustratedivider']
				this.fApi.setValue({
					name: '发起'
				})
				this.fApi.mergeRule('controll', {
					props: {
						controlltype: 1
					}
				})
				this.fApi.hidden(false, showField)
				this.fApi.hidden(false, showDivider)
			},
			setStaffNode(){
				let showField = ['nodetype','name','tag','controll','controller','event','illustrate','jump']
				//let divider = ['nodetypedivider','controlldivider','logicdivider','sonflowdivider','illustratedivider']
				let showDivider = ['nodetypedivider','controlldivider','illustratedivider']
				this.fApi.setValue({
					name: '人员',
					tag:'协同'
				})
				this.fApi.mergeRule('controll', {
					props: {
						controlltype: 2
					}
				})
				console.log(this.fApi)
				this.fApi.hidden(false, showField)
				this.fApi.hidden(false, showDivider)
				
				
			},
			setLogicNode(){
				let showField = ['nodetype','name','method','code']
				let showDivider = ['nodetypedivider','logicdivider']
				this.fApi.setValue({
					name: '逻辑'
				},{
					method: '2'
				})
				this.fApi.hidden(false, showField)
				this.fApi.hidden(false, showDivider)
			},
			setInformNode(){
				let showField = ['nodetype','name','tag','controll','controller','illustrate']
				let showDivider = ['nodetypedivider','controlldivider']
				this.fApi.setValue({
					name: '知会',
					tag:'知会'
				})
				this.fApi.mergeRule('controll', {
					props: {
						controlltype: 3
					}
				})
				this.fApi.hidden(false, showField)
				this.fApi.hidden(false, showDivider)
			},
			setSonflowNode(){
				let showField = ['nodetype','name','tag','begintype','controller','sonflow']
				let showDivider = ['nodetypedivider','sonflowdivider']
				this.fApi.setValue({
					name: '子流程',
					tag:'子流程'
				})
				this.fApi.mergeRule('controll', {
					props: {
						controlltype: 2
					}
				})
				this.fApi.hidden(false, showField)
				this.fApi.hidden(false, showDivider)
			},
			setAuditNode(){
				let showField = ['nodetype','name']
				let showDivider = ['nodetypedivider']
				this.fApi.setValue({
					name: '自动审核'
				})
				this.fApi.mergeRule('controll', {
					props: {
						controlltype: 1
					}
				})
				this.fApi.hidden(false, showField)
				this.fApi.hidden(false, showDivider)
			},
			
			
			expressionconfigButton(){
				this.expressionData = this.fApi.getValue('expressionconfig')
				this.$refs.expressionForm.modal_show()
			},
			expressionSubmit(e){
				this.fApi.setValue('expressionconfig', e.data)
				console.log(e,11233)
			},
			expressionBack(){
				this.$refs.expressionorm.modal_cancel()
			},
			
			
			
			
			eventButton() {
				this.eventData = this.fApi.getValue('event')
				this.$refs.eventForm.modal_show()
			},
			eventSubmit(e){
				this.fApi.setValue('event', e.data)
				console.log(e,11233)
			},
			eventBack(){
				this.$refs.eventForm.modal_cancel()
			},
			submit() {
				this.fApi.submit((formData) => {
					this.$emit('submit', {
						data: formData,
						type: this.extra.type
					})
					this.$emit('back')
					// let begin = false
					// this.extra.flow.forEach((item) => {
					// 	item.data.nodetype == 998
					// 	begin = true
					// })
					// if (begin && formData.nodetype == 998 && this.extra.type == 'add') {
					// 	this.$message.error('只能存在一个发起节点')
					// } else {
					// 	formData.id = this.id
					// 	if (this.extra.type == 'insert') {
					// 		formData.prenodeid = [this.extra.node[0].id]
					// 	}
					// 	this.$emit('submit', {
					// 		data: formData,
					// 		type: this.extra.type,
					// 		edge: this.extra.type == 'insert' ? {
					// 			source: this.extra.node[0],
					// 			target: this.extra.node[1],
					// 			label: formData.mark
					// 		} : {}
					// 	})
					// 	this.$emit('back')
					// }
				})
			},
		},
		components: {
			eventForm,
			expressionForm
		}
	}
</script>
